import { L as Loader } from './index-BbSRBvY_.js';

class MapsLoader extends HTMLElement {
  /** @type {String} */
  API_KEY = this.getAttribute('api-key');

  /** @type {Number} */
  longitude = parseFloat(this.getAttribute('longitude'));

  /** @type {Number} */
  latitude = parseFloat(this.getAttribute('latitude'));

  /** @type {String} */
  markerIcon = this.getAttribute('marker-icon');

  mapId = this.getAttribute('map-id');

  map;
  marker;

  connectedCallback() {
    if (!this.API_KEY || !this.longitude || !this.latitude || !this.markerIcon || !this.mapId)
      return;

    const position = { lat: this.latitude, lng: this.longitude };

    const loader = new Loader({
      apiKey: this.API_KEY,
      version: 'weekly',
    });

    // Promise for a specific library
    loader
      .importLibrary('maps')
      .then(({ Map, AdvancedMarkerElement }) => {
        this.map = new Map(this.querySelector('.map'), {
          center: position,
          zoom: 14,
          mapId: this.mapId,
        });
      })
      .then(() => loader.importLibrary('marker'))
      .then(({ AdvancedMarkerElement }) => {
        const contentImage = document.createElement('img');
        contentImage.src = this.markerIcon;
        this.marker = new AdvancedMarkerElement({
          map: this.map,
          position: position,
          content: contentImage,
        });
      })
      .catch((e) => {
        // do something
        console.error(e);
      });
  }
}

customElements.define('maps-loader', MapsLoader);
